import { Translation } from "../hooks/useTranslations";

const de: Translation = {
  common: {
    actions: "Aktionen",
    actualCost: "Tatsächliche Kosten",
    add: "Hinzufügen",
    addComponent: "Komponente hinzufügen",
    allRequests: "Alle Anfragen",
    allowQuantityVariation: "Mengenabweichung zulassen",
    alreadyPresent: "Bereits vorhanden",
    ascending: "Aufsteigend",
    author: "Autor",
    availabilityDate: "Verfügbarkeitsdatum",
    by: "Von",
    cancel: "Abbrechen",
    close: "Schließen",
    closedAndDiscarded: "Geschlossen und verworfen",
    code: "Code",
    columnNotFilterable: "Diese Spalte ist nicht filterbar",
    columnNotSortable: "Diese Spalte ist nicht sortierbar",
    componentCantBeFinalItem: "Die Komponente kann nicht mit dem Endartikel identisch sein.",
    components: "Komponenten",
    costs: "Kosten",
    cost: "Kosten",
    costPerUnit: "Kosten pro Einheit",
    createdAt: "Erstellt am",
    totalCost: "Gesamtkosten",
    createRequest: "Anfrage erstellen",
    createsKit: "Kit erstellen",
    dataHasBeenSavedSuccessfully: "Daten wurden erfolgreich gespeichert.",
    dataSyncedSuccessfully: "Daten erfolgreich synchronisiert",
    days: "Tage",
    decrease: (value: number) => `${value} verringern`,
    delete: "Löschen",
    deleteFilter: (filter: string) => `Filter für ${filter} löschen`,
    description: "Beschreibung",
    descending: "Absteigend",
    download: "Herunterladen",
    dragAndDropOrUploadAnFile: "Ziehen Sie eine Datei hierher oder klicken Sie zum Hochladen",
    dropIt: "Ablegen",
    edit: "Bearbeiten",
    editMinutes: "Minuten bearbeiten",
    email: "E-Mail",
    empty: "Leer",
    english: "Englisch",
    errorLoadingData: "Fehler beim Laden der Daten",
    expectedCost: "Erwartete Kosten",
    expectedMinutes: "Erwartete Minuten",
    expectedQuantity: "Erwartete Menge",
    exportExcel: "Excel exportieren",
    fieldCannotBeEmpty: "Das Feld darf nicht leer sein.",
    fieldContainsInvalidValueInsertBiggerOne:
      "Das Feld enthält einen ungültigen Wert, geben Sie einen größeren Wert ein.",
    fieldContainsInvalidValueInsertSmallerOne:
      "Das Feld enthält einen ungültigen Wert, geben Sie einen kleineren Wert ein.",
    fieldInvalidValue: "Das Feld enthält einen ungültigen Wert.",
    fieldValueInvalidFormat: "Der Wert hat ein ungültiges Format.",
    finalItem: "Endartikel",
    finalItemCode: "Endartikel-Code",
    finalItemQuantity: "Endartikel-Menge",
    firstName: "Vorname",
    genericError: "Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut.",
    generalData: "Allgemeine Daten",
    german: "Deutsch",
    groupedByItems: "Nach Artikeln gruppiert",
    helmets: "Helme",
    home: "Startseite",
    minutes: "Minuten",
    id: "ID",
    increase: (value: number) => `${value} erhöhen`,
    initialItem: "Ausgangsartikel",
    initialItemIsFinalItem: "Ausgangsartikel ist Endartikel",
    initialItemQuantity: "Ausgangsartikel-Menge",
    isKit: "Ist Kit",
    italian: "Italienisch",
    item: "Artikel",
    // itemsPerPackage: "Artikel pro Verpackung",
    label: "Etikett",
    lastName: "Nachname",
    loading: "Wird geladen",
    logout: "Abmelden",
    manageCosts: "Kosten verwalten",
    myArea: "Mein Bereich",
    myRequests: "Meine Anfragen",
    name: "Name",
    nextNRows: (n: number) => `Nächste ${n} Zeilen`,
    new: "Neu",
    newLabelOrPackaging: "Neues Etikett/Verpackung",
    no: "Nein",
    noItemsFound: "Keine Element gefunden.",
    notFound: "Nicht gefunden",
    offerMandatory: "Angebot erforderlich",
    onGoing: "Laufend",
    optional: "Optional",
    organization: "Organisation",
    overwrite: "Überschreiben",
    packaging: "Verpackung",
    permissions: "Berechtigungen",
    producesKit: "Stellt ein Set her",
    productionPickingNumber: "Produktions-/Kommissioniernummer",
    priorities: "Prioritäten",
    priority: "Priorität",
    processingType: "Verarbeitungsart",
    processingTypes: "Verarbeitungsarten",
    previousNRows: (n: number) => `Vorherige ${n} Zeilen`,
    pz: "STK",
    quantity: "Menge",
    rename: "Umbenennen",
    requests: "Anfragen",
    requestsByItem: "Anfragen nach Artikel",
    requestType: "Anfragetyp",
    resourceNotFound: "Die gesuchte Ressource wurde nicht gefunden.",
    roles: "Rollen",
    save: "Speichern",
    search: "Suchen",
    select: "Auswählen",
    selectRequestType: "Wählen Sie einen Anfragetyp.",
    send: "Senden",
    sendOfferTo: "Angebot senden an",
    showsMarketingFields: "Marketing-Felder anzeigen",
    status: "Status",
    supervisor: "Vorgesetzter",
    sync: "Synchronisieren",
    testEnvironment: "Testumgebung",
    totalAttachedDocuments: "Gesamtanzahl der angehängten Dokumente",
    type: "Typ",
    types: "Typen",
    unitOfMeasure: "Maßeinheit",
    update: "Aktualisieren",
    usedProducts: "Verwendete Produkte",
    usedProductsFor: "Verwendete Produkte für ",
    usedQuantity: "Verwendete Menge",
    views: "Ansichten",
    workingMinutes: "Arbeitsminuten",
    writeMessage: "Nachricht schreiben",
    yes: "Ja",
    youAreNotAllowedToAccessThisApplication: "Sie sind nicht berechtigt, auf diese Anwendung zuzugreifen",
  },

  groupedRequests: {
    numberOfRequests: "Anzahl der Anfragen",
    totalExpectedMinutes: "Gesamt erwartete Minuten",
    totalExpectedMinutesCost: "Gesamtkosten erwartete Minuten",
    productionTotalMinutes: "Gesamt Produktionsminuten",
    totalProductionMinutesCost: "Gesamtkosten Produktionsminuten",
    totalInitialItemsCost: "Gesamtkosten Ausgangsartikel",
    totalPackagingsAndLabelsCost: "Gesamtkosten Verpackungen und Etiketten",
    short: {
      numberOfRequests: "Anz. Anfragen",
      totalExpectedMinutes: "Ges. erw. Min.",
      totalExpectedMinutesCost: "Ges. Kosten erw. Min.",
      productionTotalMinutes: "Ges. Prod.-Min.",
      totalProductionMinutesCost: "Ges. Kosten Prod.-Min.",
      totalInitialItemsCost: "Ges. Kosten Ausgangsartikel",
      totalPackagingsAndLabelsCost: "Ges. Kosten Verpck. u. Etiketten",
    },
  },

  processingRequests: {
    delete: "Bearbeitungsanfrage löschen",
    plural: "Bearbeitungsanfragen",
    newProcessingRequest: "Neue Bearbeitungsanfrage",
    editProcessingRequest: "Bearbeitungsanfrage bearbeiten",
    editAvailabilityDate: "Verfügbarkeitsdatum bearbeiten",
    requestRecap: "Anfragenzusammenfassung",

    questions: {
      delete: "Möchten Sie diese Bearbeitungsanfrage wirklich löschen?",
    },

    errors: {
      finalItemMoreInitialItems: "Ein Endartikel darf nur einen einzigen Ausgangsartikel enthalten",
      invalidAvailabilityDate: "Ungültiges Verfügbarkeitsdatum",
      notFound: "Bearbeitungsanfrage nicht gefunden",
      missingFinalItem: "Eine Bearbeitungsanfrage erfordert die Definition mindestens eines Endartikels",
      missingKitComponents: "Für eine Bearbeitungsanfrage (Kit) ist mindestens eine Komponente erforderlich",
      missingPackagingsOrLabels: "Die Bearbeitungsanfrage erfordert Verpackungen oder Etiketten, um fortzufahren",
      missingExpectedMinutes: "Erwartete Minuten sind erforderlich, um fortzufahren",
      missingProductionMinutes: "Produktionsminuten sind erforderlich, um fortzufahren",
    },

    status: {
      open: "Offen",
      accepted: "Akzeptiert",
      waitingConfirmation: "Warten auf Bestätigung",
      offerApproved: "Angebot genehmigt",
      inProgress: "In Bearbeitung",
      closed: "Abgeschlossen",
      refused: "Abgelehnt",
      discarded: "Verworfen",
      actions: {
        takeInCharge: "Übernehmen",
        sendOffer: "Angebot senden",
        accept: "Akzeptieren",
        refuse: "Ablehnen",
        discard: "Verwerfen",
        start: "Starten",
        finishClose: "Beenden/Abschließen",
      },
      executedActions: {
        requestCreated: "Anfrage erstellt",
        requestAccepted: "Anfrage angenommen",
        offerSent: "Angebot gesendet",
        offerApproved: "Angebot genehmigt",
        workStarted: "Arbeiten begonnen",
        workCompleted: "Arbeiten abgeschlossen",
        offerRefused: "Angebot abgelehnt",
        requestDiscarded: "Anfrage verworfen",
      },
    },
  },

  labels: {
    plural: "Etiketten",
    delete: "Etikett löschen",
    newLabel: "Neues Etikett",
    editLabel: "Etikett bearbeiten",

    questions: {
      delete: "Möchten Sie dieses Etikett wirklich löschen?",
    },

    errors: {
      notFound: "Das angeforderte Etikett konnte nicht gefunden werden",
      codeExists: "Ein Etikett mit dem angegebenen Code ist bereits definiert",
      inUseByRequests: "Das Etikett wird noch verwendet und kann nicht gelöscht werden",
    },
  },

  items: {
    plural: "Artikel",
    delete: "Artikel löschen",
    newItem: "Neuer Artikel",
    editItem: "Artikel bearbeiten",
    deleteKitAndComponents: "Kit & Komponenten löschen",
    deleteJustKit: "Nur Kit löschen",
    deleteComponentsInfo: "Komponenten, die in anderen Kits oder Anfragen verwendet werden, werden nicht gelöscht",

    questions: {
      deleteComponents: "Möchten Sie die mit diesem Artikel verbundenen Komponenten löschen?",
      delete: "Möchten Sie diesen Artikel wirklich löschen?",
    },

    errors: {
      notFound: "Der angeforderte Artikel konnte nicht gefunden werden",
      alreadyExists: "Der angegebene Artikel ist bereits definiert",
      inUseByRequests: "Der Artikel wird noch verwendet und kann nicht gelöscht werden",
      alreadyAdded: "Der ausgewählte Artikel wurde bereits hinzugefügt",
    },
  },

  users: {
    plural: "Benutzer",
    addUser: "Benutzer hinzufügen",
    editUser: "Benutzer bearbeiten",

    errors: {
      notFound: "Der angeforderte Benutzer konnte nicht gefunden werden",
      alreadyExists: "Der ausgewählte Benutzer wurde bereits hinzugefügt",
      emailAlreadyExists: "Ein anderer Benutzer mit derselben E-Mail-Adresse wurde bereits hinzugefügt",
    },
  },

  costCenters: {
    singular: "Kostenstelle",
    plural: "Kostenstellen",
    delete: "Kostenstelle löschen",
    newCostCenter: "Neue Kostenstelle",
    editCostCenter: "Kostenstelle bearbeiten",

    questions: {
      delete: "Möchten Sie diese Kostenstelle wirklich löschen?",
    },

    errors: {
      notFound: "Die angeforderte Kostenstelle konnte nicht gefunden werden",
      codeUsed: "Eine Kostenstelle mit dem angegebenen Code ist bereits definiert",
      nameUsed: "Eine Kostenstelle mit dem angegebenen Namen ist bereits definiert",
      inUseByRequests: "Die Kostenstelle wird noch verwendet und kann nicht gelöscht werden",
    },
  },

  costObjects: {
    singular: "Kostenträger",
    plural: "Kostenträger",
  },

  documents: {
    add: "Dokument hinzufügen",
    all: "Alle Dokumente",
    alreadyPresent: "Dokument bereits vorhanden.",
    plural: "Dokumente",
    rename: "Dokument umbenennen",
    delete: "Dokument löschen",
    search: "Dokumente suchen",

    questions: {
      delete: "Möchten Sie dieses Dokument wirklich löschen?",
      overwrite: "Möchten Sie das bereits vorhandene Dokument überschreiben?",
    },

    errors: {
      nameAlreadyExists: "Ein Dokument mit diesem Namen existiert bereits",
      extensionChanged: "Die Erweiterung des Dokuments darf nicht geändert werden",
      sizeTooLarge: "Die Dateigröße des Dokuments ist zu groß",
    },
  },

  notes: {
    note: "Notiz",
    addNote: "Notiz hinzufügen",
    editNote: "Notiz bearbeiten",
    plural: "Notizen",
  },

  priorities: {
    plural: "Prioritäten",
    delete: "Priorität löschen",
    newPriority: "Neue Priorität",
    editPriority: "Priorität bearbeiten",

    questions: {
      delete: "Möchten Sie diese Priorität wirklich löschen?",
    },

    errors: {
      notFound: "Die angeforderte Priorität konnte nicht gefunden werden",
      nameUsed: "Eine Priorität mit dem angegebenen Namen ist bereits definiert",
      inUseByRequests: "Die Priorität wird noch verwendet und kann nicht gelöscht werden",
    },
  },

  packagings: {
    plural: "Verpackungen",
    delete: "Verpackung löschen",
    newPackaging: "Neue Verpackung",
    editPackaging: "Verpackung bearbeiten",

    questions: {
      delete: "Möchten Sie diese Verpackung wirklich löschen?",
    },

    errors: {
      notFound: "Die angeforderte Verpackung konnte nicht gefunden werden",
      codeExists: "Eine Verpackung mit dem angegebenen Code ist bereits definiert",
      inUseByRequests: "Die Verpackung wird noch verwendet und kann nicht gelöscht werden",
    },
  },

  processingRequestTypes: {
    delete: "Anfragetyp löschen",
    newType: "Neuer Anfragetyp",
    editType: "Anfragetyp bearbeiten",

    questions: {
      delete: "Möchten Sie diesen Anfragetyp wirklich löschen?",
    },

    errors: {
      notFound: "Der angeforderte Typ konnte nicht gefunden werden",
      nameUsed: "Ein Bearbeitungsanfragetyp mit dem angegebenen Namen ist bereits definiert",
      inUseByRequests: "Der Bearbeitungsanfragetyp wird noch verwendet und kann nicht gelöscht werden",
    },
  },

  suppliers: {
    singular: "Lieferant",
    plural: "Lieferanten",
    delete: "Lieferant löschen",
    newSupplier: "Neuer Lieferant",
    editSupplier: "Lieferant bearbeiten",

    questions: {
      delete: "Möchten Sie diesen Lieferanten wirklich löschen?",
    },

    errors: {
      notFound: "Der angeforderte Lieferant konnte nicht gefunden werden",
      codeUsed: "Ein Lieferant mit dem angegebenen Code ist bereits definiert",
      inUseByRequests: "Der Lieferant wird noch verwendet und kann nicht gelöscht werden",
    },
  },

  errors: {
    genericError: "Ein Fehler ist aufgetreten, bitte versuchen Sie es erneut.",
    finalItemCannotMatchInitialItem: "Das Endartikel kann nicht mit dem Ausgangsartikel übereinstimmen",
  },

  warnings: {
    notAllComponentsDeleted: "Einige der Kit-Komponenten wurden gelöscht",
  },
};
export default de;
